
import './App.css';

import Calculator from './component/calculator'

function App() {
  return (
    <div className="App">
      <Calculator/>
    </div>
  );
}

export default App;
